import { createAction } from 'redux-actions';

export const setUnreadMessages = createAction('app/SET_UNREAD_MESSAGES');
